module.exports = __webpack_public_path__ + "static/media/Fuku70x70.a9b922a3.png";